import axios from 'axios'
import store from '@/store'

class ApiService {
    constructor () {
        this.root = process.env.API_ROOT
    }
    post (url, data, type = null) {
        console.log('[POST] // API CALL : ', url)
        return new Promise((resolve, reject) => {
            axios.post(this.root + url, data, this.getHeader())
            .then(result => {
                if (!result.data.success || result.data.success === true) {
                    resolve(result);
                } else if (result.data.success === false && result.data.error) {
                    reject(result.data.error);
                } else {
                    reject();
                }
            })
            .catch(error => {
                console.error(error)
                if (error.response.status === 401 && (error.response.data.message === 'Token expiré, reconnectez-vous pour en obtenir un nouveau !' || error.response.data.message === 'Token invalide, reconnectez-vous pour en obtenir un nouveau !')) {
                    this.refreshToken().then(() => {
                        this.post(url, data)
                        .then((result) => {
                            resolve(result)
                        }).catch((error) => {
                            reject(error)
                        })
                    })
                } else if (error.response.status === 403) {
                    store.commit('LOGOUT')
                } else {
                    reject(error)
                }
            })
        })
    }
    get (url) {
        console.log('[GET] // API CALL : ', url)
        return new Promise((resolve, reject) => {
            axios.get(this.root + url, this.getHeader())
            .then(result => {
                if (!result.data.success || result.data.success === true) {
                    resolve(result);
                } else if (result.data.success === false && result.data.error) {
                    reject(result.data.error);
                } else {
                    reject();
                }
            })
            .catch(error => {
                if (error.response.status === 401) {
                    this.refreshToken().then(() => {
                        this.get(url).then((result) => {
                            resolve(result)
                        }).catch((error) => {
                            reject(error)
                        })
                    })
                } else if (error.response.status === 403) {
                    store.commit('LOGOUT')
                } else {
                    reject(error)
                }
            })
        })
    }
    refreshToken () {
      let refresh = store.state.users.refresh
      return new Promise((resolve, reject) => {
        console.log('REFRESH TOKEN', refresh)
        axios.post(this.root + 'api/token/refresh', {
            refresh_token: refresh
        })
        .then(result => {
            console.log('TOKEN REFRESH SUCCESS')
            store.commit('SET_TOKENS', result.data)
            resolve()
        })
        .catch(error => {
            reject(error)
            store.commit('LOGOUT')
            window.location = '/login'
        })
      })
    }
    getHeader () {
      let token = store.state.users.token
      if (token !== null) {
        return {
          headers: {
            'X-Auth-Token': 'Bearer ' + token
          }
        }
      } else {
        return null
      }
    }
}

const apiService = new ApiService()

export default apiService



// WEBPACK FOOTER //
// ./src/services/apiService.js